export enum UserReducerActionNames {
  UPDATE_USER_FIELD = 'UPDATE_USER_FIELD',
  UPDATE_USER_DATA = 'UPDATE_USER_DATA'
}
